export default __webpack_public_path__ + "static/media/IMG_0126.aab35306.jpeg";